import { filterByData } from '@/components/services/report-manager/utils'

import render from './render'

export default {
  name: 'FilterByEntity',

  mixins: [ filterByData ],

  render
}
